import {
  Box,
  Button,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
} from "@mui/material";
import React from "react";
import {
  blackShade19,
  blueColor04,
  borderTextBoxColor,
  greenStatusColor01,
  greyColor060,
  greyColor42,
  greyColor53,
  greyColor54,
  greyColor56,
  lightgreenColor04,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { toTitleCase } from "../../../utils/validationUtils";

function CRMSalesByAreaSection({ orderReportByCity }) {
  return (
    <Stack
      sx={{
        border: "1px solid " + greyColor56,
        borderRadius: "12px",
        // pb: 2,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: "9px 15px" }}
      >
        <Typography
          fontSize={13.5}
          fontWeight={600}
          color={blackShade19}
          lineHeight={1.5}
        >
          Sales by Area
        </Typography>
        {/* <Typography
          fontSize={11}
          fontWeight={500}
          color={blueColor04}
          component={Button}
          lineHeight={1.5}
          sx={{
            textDecoration: "underline",
            textTransform: "none",
            p: "0px",
            "&:hover": { background: "transparent" },
          }}
        >
          View More
        </Typography> */}
      </Box>

      <Box sx={styles.tableWrapper} borderRadius={"12px"}>
        <TableContainer
          sx={styles.tableContainer}
          component={Box}
          borderRadius={"12px"}
        >
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  position: "sticky !important",
                  top: 0,
                  backgroundColor: greyColor53,
                  zIndex: 20,
                }}
              >
                <TableCell
                  sx={{ ...styles.tableCell, width: "80%" }}
                  align="center"
                >
                  City, State.
                </TableCell>
                <TableCell sx={styles.tableCell} align="center">
                  No. of Orders
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: whiteColor }}>
              {orderReportByCity?.slice(0, 3)?.map((item, index) => (
                <TableRow
                  key={index}
                  sx={{
                    borderBottom: `1px solid ${borderTextBoxColor}`,
                    verticalAlign: "top",
                  }}
                >
                  <TableCell sx={{ ...styles.tableBodyCell, maxWidth: "80%" }}>
                    <Box display="flex" gap="8px">
                      <Box
                        component="img"
                        src="/./assets/image/location-icon.svg"
                        sx={{
                          width: "20px",
                          height: "auto",
                        }}
                      />
                      <Box>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: blackShade19,
                            lineHeight: "16px",
                          }}
                        >
                          {toTitleCase(item?.cityState?.city)},{" "}
                          {toTitleCase(item?.cityState?.state)}
                        </Typography>
                        {/* <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 400,
                            color: greyColor060,
                            lineHeight: "16px",
                          }}
                        >
                          {item?.cityState?.pinCode
                            ? item?.cityState?.pinCode
                            : "N/A"}
                        </Typography> */}
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <Box
                      sx={{
                        fontWeight: 600,
                        fontSize: "12px",
                        color: greenStatusColor01,
                        textAlign: "center",
                      }}
                    >
                      {item?.orderCount}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Stack>
  );
}

export default CRMSalesByAreaSection;

const styles = {
  tableWrapper: {
    width: "100%",
    // borderRadius: "8px",
    border: `1px solid ${borderTextBoxColor}`,
    borderBottom: "none",
    overflow: "hidden",
  },

  tableContainer: {
    // borderRadius: "8px",
    maxWidth: "100%",
  },

  tableCell: {
    color: blackShade19,
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: 1.45,
    whiteSpace: "nowrap",
    padding: "10px 15px",
    backgroundColor: greyColor53,
    textAlign: "start",
    // borderRight: `1px solid ${whiteColor}`,
  },

  tableBodyCell: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    whiteSpace: "nowrap",
    color: blackShade19,
    padding: "11px 15px !important",
    textAlign: "start",
  },
};
